module.exports = __webpack_public_path__ + "static/marketval-7319cb69210c348f9a323d2ec4ec6af8.png";